import { useCallback, useMemo } from 'react';

import { shouldRefetchPlannerDataState } from './AddCardToPlannerPopover/shouldRefetchPlannerDataState';
import { pendingAuthSuccessFlagState } from './pendingAuthSuccessFlagState';
import { plannerLoadingState } from './plannerLoadingState';
import { usePlannerRef } from './usePlannerRef';

/**
 * Hook that provides the onSuccessfulAuth callback.
 *
 * Safe to call from components that unmount during the auth flow (e.g., popovers).
 * Triggers refetch and scroll, and signals that success flags should be shown
 * via shared state. The actual flag display is handled by {@link useAuthSuccessFlag},
 * which must be called from a component that stays mounted (e.g., Planner).
 */
export const useOnSuccessfulAuth = () => {
  const { plannerRef } = usePlannerRef();
  const calendarApi = plannerRef.current?.getApi();

  const scrollTime = useMemo(() => {
    return new Date().getHours() < 9 ? `${new Date().getHours()}:00` : '8:45';
  }, []);

  const onSuccessfulAuth = useCallback(async () => {
    // Publish 'refetching' at the trigger site so the loading state is
    // visible before the refetch useEffect fires in usePlannerData.
    plannerLoadingState.setSourcePhase('events', { status: 'refetching' });
    shouldRefetchPlannerDataState.setValue(true);
    calendarApi?.scrollToTime(scrollTime);
    pendingAuthSuccessFlagState.setValue(true);
  }, [calendarApi, scrollTime]);

  return { onSuccessfulAuth };
};
